module.exports = __webpack_public_path__ + "img/BOWTIE 3 GREEN.49a39fb.svg";